export default __webpack_public_path__ + "static/media/4.41114b1b.jpg";